
function collapsible(){
  $(".faqampm-q").click( function () {
    var container = $(this).parents(".faqampm-c");
    var answer = container.find(".faqampm-a");
    var trigger = container.find(".faqampm-img");
    
    answer.slideToggle(200);
    
    if (trigger.hasClass("faqampm-o")) {
      trigger.removeClass("faqampm-o");
    }
    else {
      trigger.addClass("faqampm-o");
    }
  });
}

export {collapsible}



// WEBPACK FOOTER //
// ./src/components/beautiful-chat/js/collapsible.js